import { useQuery } from '@tanstack/react-query';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import Animation from '@/components/Animation/Animation';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { userTransactionsQueryOptions } from '@/queries/userTransactionsQuery/userTransactionsQuery';
import Button from '@/ui-kit/components/Button/Button';
import { assertCondition } from '@/utils/typescript';

const DirectDebitChargeInProgress = ({ closeModal }: ModalProps) => {
  const { t } = useTranslation(['Modal', 'Button']);

  const { data: chargeInProgressAmount, isPending } = useQuery({
    ...userTransactionsQueryOptions(),
    select: data =>
      data.reduce(
        (sum, transaction) => (transaction.status === 'CHARGE' ? sum + transaction.amount : sum),
        0,
      ),
  });

  if (isPending) {
    return null;
  }

  assertCondition(
    chargeInProgressAmount !== undefined,
    'Charge-in-progress amount must be available when opening DirectDebitChargeInProgress modal.',
  );

  return (
    <Modal
      title={t('DirectDebitChargeInProgress.title')}
      topLeftContent={<Animation animation="timeHourglass" width="24px" />}
    >
      <p>{t('DirectDebitChargeInProgress.info', { chargeInProgressAmount })}</p>
      <ModalActions>
        <Button onClick={closeModal}>{t('Button:clear')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default DirectDebitChargeInProgress;
